import { TooltipProvider } from '@teach/ui'
import type { CourseWithoutBlocks } from '@/types/course'
import { QuickLangSwitch } from '@/features/editor/components/EditorHeader/QuickLangSwitch'
import { UndoRedoButtons } from '@/features/editor/components/EditorHeader/UndoRedoButtons'
import { SaveStatusIndicator } from '@/features/editor/components/EditorHeader/SaveStatusIndicator'
import { SoundToggleButton } from '@/features/editor/components/EditorHeader/SoundToggleButton'
import { TimelineCollapseToggle } from './TimelineCollapseToggle'

interface Props {
  course: CourseWithoutBlocks
  collapsed: boolean
  onToggleCollapsed: () => void
}

/**
 * Телефон и планшет (уже `lg`): инструменты — баром над уроками, а не стеклом поверх
 * холста: язык, отменить/вернуть, звук и справа — свернуть ленту. Настройки урока —
 * шестерёнкой на выбранной плашке (`LessonPill`).
 */
export const MobileTimelineBar = ({ course, collapsed, onToggleCollapsed }: Props) => {
  return (
    <TooltipProvider delayDuration={200}>
      <div className="flex items-center gap-1 lg:hidden">
        <QuickLangSwitch course={course} />
        <UndoRedoButtons />
        <SaveStatusIndicator />
        <SoundToggleButton />
        <TimelineCollapseToggle collapsed={collapsed} onToggle={onToggleCollapsed} />
      </div>
    </TooltipProvider>
  )
}
